__turbopack_context__.v({
  "className": "inter_7f3bd01d-module__QxER6W__className",
  "variable": "inter_7f3bd01d-module__QxER6W__variable",
});
